"use strict";const e=require("./Modal.js");module.exports=e;
//# sourceMappingURL=index.js.map
